import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';

import config from "../../config/config";
import axios from 'axios';

const styles = theme => ({
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    card: {
        width: "100%",
        height: '68vh',
    },
    header: {
          textAlign: "center"
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
        height: 56
    },
    content: {
          textAlign: "center",
        height: '55vh',
        overflow: "auto"
    },
    actionContent: {
          textAlign: "center",
        height: '50vh',
        overflow: "auto"
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8,
        },
    },
    transaction: {
        paddingTop: 10,
        overflow: "auto",
        height: "10vh"
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
});

class AttachmentList extends React.Component {
    constructor(props) {
        super(props);
    }

    handleFileDownload = (id,name) => {
        // axios.get().then(res=>{
        //     console.log(res);
        // }).catch(error => {console.log(error.response)})
        axios({
            url: config.attachment + "/" + id,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            // console.log(id)
            // console.log(name)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
          }).catch(error => {console.log(error.response)});
    };

    render(){
        const { classes } = this.props;
        // {this.props.attachments ?}
        return (
            <div className={classes.root}>
                <Toolbar>Attachments</Toolbar>
                    <List dense='true'>
                        {this.props.attachments ? this.props.attachments.map(row=>{
                            return <ListItem>{row.file_name}
                                {/* <ListItemText primary={row.file_name}/> */}
                                <IconButton className={classes.button} onClick={() => this.handleFileDownload(row.id, row.file_name)}>
                                    <GetAppIcon></GetAppIcon>
                                </IconButton>                                    
                            </ListItem>
                        }):null}
                    </List>
            </div>
        )
    }
}

AttachmentList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AttachmentList);


// WEBPACK FOOTER //
// ./src/components/Routines/AttachmentList.js